/* cpb-popups.js — safe for CSP (no inline code needed) */
(() => {
  if (window.__CPB_POPUPS_LOADED__) return;
  window.__CPB_POPUPS_LOADED__ = true;

  function CPB_OPEN(id) {
    const m = document.getElementById(id);
    if (!m) return;
    m.setAttribute('open', '');
    m.removeAttribute('aria-hidden');
    document.documentElement.style.overflow = 'hidden';
    const f =
      m.querySelector('[data-cpb-close]') ||
      m.querySelector('button,[href],input,select,textarea,[tabindex]');
    if (f && f.focus) f.focus();
  }
  function CPB_CLOSE(modalEl) {
    const m = modalEl;
    if (!m) return;
    m.removeAttribute('open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  window.CPB_OPEN = CPB_OPEN;
  window.CPB_CLOSE = CPB_CLOSE;

  // Click delegation (works across re-renders)
  document.addEventListener('click', (e) => {
    const opener = e.target.closest?.('[data-cpb-open]');
    if (opener) {
      e.preventDefault();
      CPB_OPEN(opener.getAttribute('data-cpb-open'));
      return;
    }
    const closer = e.target.closest?.('[data-cpb-close]');
    if (closer) {
      CPB_CLOSE(closer.closest('.cpb-modal'));
    }
  });

  // Esc to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.cpb-modal[open]');
      if (open) CPB_CLOSE(open);
    }
  });

  // Countup (lazy) — runs for any section that has data-countup nodes
  function initCountups(scope = document) {
    const els = scope.querySelectorAll?.('[data-countup]');
    if (!els || !els.length) return;
    const started = new WeakSet();
    function animate(el) {
      if (started.has(el)) return;
      started.add(el);
      const target = parseFloat(el.getAttribute('data-target') || '0');
      const decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      const duration = parseInt(el.getAttribute('data-duration') || '1200', 10);
      const prefix = el.getAttribute('data-prefix') || '';
      const suffix = el.getAttribute('data-suffix') || '';
      let t0 = null;
      const fmt = (v) => {
        const p = Math.pow(10, decimals);
        const n = Math.round(v * p) / p;
        return prefix + n.toFixed(decimals) + suffix;
      };
      function step(ts) {
        if (!t0) t0 = ts;
        const p = Math.min(1, (ts - t0) / duration);
        const e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * e);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(target);
      }
      requestAnimationFrame(step);
    }
    try {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((en) => en.isIntersecting && animate(en.target)),
        { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );
      els.forEach((el) => io.observe(el));
    } catch {
      els.forEach(animate);
    }
  }

  // Init now…
  if (document.readyState !== 'loading') initCountups(document);
  else document.addEventListener('DOMContentLoaded', () => initCountups(document));

  // …and for Theme Editor events
  document.addEventListener('shopify:section:load', (e) => initCountups(e.target));
  document.addEventListener('shopify:section:select', (e) => initCountups(e.target));
})();
